const Box = ({ children }) => {
  return (
    <div className={'mx-[8%] rounded-2xl border-2 border-dotted border-primary p-4 lg:mx-0 lg:p-8'}>{children}</div>
  );
};

export default Box;
